module.exports = __webpack_public_path__ + "static/finley-coloring-book-96a7ae26337d8c97fb5157a34cf906c2.jpg";